import { createFileRoute } from '@tanstack/react-router';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { Button } from '~/components/button';
import { api } from '~/lib/api';

export const Route = createFileRoute('/_authed/founder/time-audit')({
  component: TimeAuditPage,
});

function TimeAuditPage() {
  const [estimate, setEstimate] = useState('');
  const run = useMutation({ mutationFn: () => api.timeAuditRun(estimate.trim()) });

  return (
    <section className="mx-auto max-w-2xl px-4 py-12">
      <h1 className="text-2xl font-semibold tracking-tight">time-truth audit</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        monthly. say how the month went; we compare to journal timestamps and calendar shape.
      </p>

      <textarea
        value={estimate}
        onChange={(e) => setEstimate(e.target.value)}
        rows={6}
        placeholder="say it plainly. 'i worked 60h/week, saw friends twice, slept 6h average, took no full day off.'"
        className="mt-6 w-full rounded-[var(--radius)] border border-input bg-background p-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
      />
      <div className="mt-3">
        <Button disabled={!estimate.trim() || run.isPending} onClick={() => run.mutate()}>
          {run.isPending ? 'auditing…' : 'audit'}
        </Button>
      </div>

      {run.data && (
        <article className="mt-8 rounded-[var(--radius)] border border-border p-4 text-sm whitespace-pre-wrap">
          {run.data.audit}
        </article>
      )}
    </section>
  );
}
